import readline from 'readline/promises';
import { stdin as input, stdout as output } from 'process';

export async function askQuestion(query: string): Promise<string> {
  const rl = readline.createInterface({ input, output });
  try {
    return (await rl.question(query)).trim();
  } finally {
    rl.close();
  }
}
// rl.question(query): Prints the question (query) to the screen and waits.
// await: Pauses the program right here. 
// The execution is frozen until the user types their answer and hits the [Enter] key.
// .trim(): Removes any accidental whitespace (spaces or tabs) 
// from the beginning or end of the user's input (e.g., "  yes  " becomes "yes").
// rl.close() (Crucial Step):
// Closes the keyboard read stream and frees up system resources.
// Why it's in finally: If you do not close readline,
//  Node.js will think you still want to listen to the keyboard,
// and the terminal process will freeze/hang forever even after your script finishes. 
// Placing it in finally guarantees it closes even if an error occurs.